const actionTypeIdentifier = '8E6F3CA7-FAEB-484E-89ED-9F5D0DEA4CCD'; // to generate open ssms run select newid()

//location form actions
export const setSubscriptionDetails = `SET-WIRELESS-REPLACE-DEVICE-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setUserLocation = `SET-WIRELESS-REPLACE-DEVICE-USER-LOCATION-${actionTypeIdentifier}`;
export const setCountryOptions = `SET-WIRELESS-REPLACE-DEVICE-COUNTRY-OPTIONS-${actionTypeIdentifier}`;
export const setAddressOptions = `SET-WIRELESS-REPLACE-DEVICE-ADDRESS-OPTIONS-${actionTypeIdentifier}`;
export const setEquipmentOptions = `SET-WIRELESS-REPLACE-DEVICE-EQUIPMENT-OPTIONS-${actionTypeIdentifier}`;
export const setBusinessCaseOptions = `SET-WIRELESS-REPLACE-DEVICE-BUSINESS-CASE-OPTIONS-${actionTypeIdentifier}`;
export const setDeviceOptions = `SET-WIRELESS-REPLACE-DEVICE-DEVICE-OPTIONS-${actionTypeIdentifier}`;
export const setDeviceAccessories = `SET-WIRELESS-REPLACE-DEVICE-DEVICE-ACCESSORIES-${actionTypeIdentifier}`;
export const setServiceTypeDetails = `SET-WIRELESS-REPLACE-DEVICE-SERVICE-TYPE-DETAILS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELESS-REPLACE-DEVICE-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const setFormLoading = `SET-WIRELESS-REPLACE-DEVICE-FORM-LOADING-${actionTypeIdentifier}`;
export const setResetLoading = `SET-RESET-REPLACE-DEVICE-FORM-LOADING-${actionTypeIdentifier}`;

export const wirelessReplaceDeviceModel = {
    circuitCode: ''
    , circuitId: 0
    , equipmentInventoryId: 0
    , mobileServiceModel: []
    , accessoryDetailsModel: []
    , countryCode: 'US'
    , billingLocationAddressId: ''
    , otherLocationAddress: ''
    , businessCaseId: 0
    , businessJustification: ''
    , additionalInformation: ''
    , deliveryAddress: ''
}
